<div wproTrapFocus class="fdx-c-modal">
  <div class="fdx-c-modal__backdrop"></div>
  <div class="fdx-c-modal__main  fdx-c-modal__main--medium">
    <div class="fdx-c-modal__body">
      @if (poprModalPackage.config?.title) {
        <h3 class="fdx-c-modal__title">
          {{poprModalPackage.config?.title}}
        </h3>
      }
      <div class="fdx-c-modal__description" #dynamicComponent></div>
    </div>
    <div class="fdx-c-modal__footer">
      <button (click)="close()" class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon">
        <ciam-icon class="fdx-c-icon" aria-hidden="true" key="cross"></ciam-icon>
      </button>
    </div>
  </div>
</div>
